import type { MegaGroup, NavLink } from '../types/content';
import { CALENDAR_URL, STUDENT_LOGIN_URL } from './site';

export const mainNav: NavLink[] = [
  { label: 'CCW Permits', to: '/ccw-permits' },
  { label: "Women's Training", to: '/womens-training' },
  { label: 'NRA & USCCA', to: '/nra-uscca' },
  { label: 'Packages & Gift Cards', to: '/packages' },
  { label: 'About', to: '/about' },
  { label: 'Reviews', to: '/reviews' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Contact', to: '/contact' },
];

export const megaGroups: MegaGroup[] = [
  {
    title: 'Get Your Permit',
    links: [
      { label: 'Multi-State CCW', code: 'CCW', to: '/courses/multi-state-ccw' },
      { label: 'NV CCW Renewal', code: 'RENEW', to: '/courses/nv-ccw-renewal' },
    ],
  },
  {
    title: 'Defensive Handgun',
    links: [
      { label: 'Intro to Defensive Handgun', code: 'ITDH', to: '/courses/itdh' },
      { label: 'Fundamentals of Concealed Carry', code: 'FOCC', to: '/courses/focc' },
      { label: 'Fundamentals of Home Defense', code: 'FOHD', to: '/courses/fohd' },
      { label: 'Intuitive Defensive Shooting', code: 'IDS', to: '/courses/ids' },
      { label: 'Low Light Defensive Handgun', code: 'LLDH', to: '/courses/low-light' },
      { label: 'Dynamic Defensive Handgun', code: 'DDH', to: '/courses/ddh' },
    ],
  },
  {
    title: 'Carbine',
    links: [
      { label: 'Intro to Defensive Carbine', code: 'ITDC', to: '/courses/itdc' },
      { label: 'Dynamic Defensive Carbine', code: 'DDC', to: '/courses/ddc' },
    ],
  },
  {
    title: 'Certifications',
    links: [
      { label: 'NRA Student Courses', to: '/nra-uscca#nra-student' },
      { label: 'NRA Instructor Courses', to: '/nra-uscca#nra-instructor' },
      { label: 'USCCA Fundamentals', to: '/courses/uscca-dsf' },
    ],
  },
  {
    title: 'Private Training',
    links: [
      { label: 'Private 1-on-1', to: '/private-training' },
      { label: 'Couples & Groups', to: '/private-training' },
      { label: 'Corporate & Organizations', to: '/private-training' },
    ],
  },
];

export const footerLinks: NavLink[] = [
  { label: 'Courses', to: '/courses' },
  { label: 'Calendar', to: CALENDAR_URL, external: true },
  { label: 'Packages', to: '/packages' },
  { label: 'Gift Certificates', to: '/packages#gift' },
  { label: 'Blog', to: '/blog' },
  { label: 'Wall of Love', to: '/reviews' },
  { label: 'Refund Policy', to: '/refund-policy' },
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Terms', to: '/terms' },
  { label: 'Student Login', to: STUDENT_LOGIN_URL, external: true },
];
